<div class="user-overlay-header">
  @if (isUserLoading()) {
    <at-skeleton class="user-overlay-avatar" />
    <at-skeleton class="user-overlay-username" />
    <at-skeleton class="user-overlay-email" />
  } @else {
    <at-avatar class="user-overlay-avatar" [name]="username()" />
    <span class="body-md user-overlay-username">{{ username() }}</span>
    <span class="caption-md user-overlay-email">{{ email() }}</span>
  }
</div>

<ul class="user-overlay-list">
  <li class="user-overlay-item">
    <a ariaCurrentWhenActive="page" routerLink="/account" routerLinkActive="active-link">
      <at-icon>settings</at-icon>
      Account
    </a>
  </li>

  <li class="user-overlay-item">
    <a ariaCurrentWhenActive="page" routerLink="/billing" routerLinkActive="active-link">
      <at-icon>credit_card</at-icon>
      Billing
    </a>
  </li>

  <!--
    Opens the cookie consent kit's choices (AT-2748). Here rather than in the sidebar foot, which
    carries the profile row and nothing else (DESIGN §8); this menu is that row unfolding, and it is
    also the phone header's account menu. Above Sign out, so the way out stays last.
  -->
  <li class="user-overlay-item">
    <button aria-haspopup="dialog" type="button" (click)="openCookieSettings()">
      <at-icon>cookie</at-icon>
      Cookie settings
    </button>
  </li>

  <!-- Sentence case like the items above, not the shared dictionary's "Sign Out" (AT-2637). -->
  <li class="user-overlay-item">
    <button type="button" (click)="logout.emit()">
      <at-icon>logout</at-icon>
      Sign out
    </button>
  </li>
</ul>

<button class="cdk-visually-hidden" type="button" (click)="close.emit()">Close overlay</button>
